import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import styles from './MessageNotification.module.css';
import { LoadingButton } from '@mui/lab';
import Spinner from 'views/Components/LoadingSinner';

const MessageDialog = ({
    open,
    onClose,
    title = 'Information',
    message,
    agreeText = 'Confirm',
    disagreeText = 'Cancel',
    onAgree,
    onDisagree,
    showActions = true,
    disableBackdropClick,
    customClass = '',
    showCloseButton = true,
    agreeLoading = false,
    disAgreeLoading = false,
    htmlContent,
    dialogWidth
}) => {
    // console.log('htmlContent', htmlContent);

    return (
        <Dialog
            open={open}
            maxWidth={false}
            onClose={disableBackdropClick ? undefined : onClose}
            aria-labelledby="message-dialog-title"
            classes={{ paper: `${styles.dialogPaper} ${customClass}` }}
            BackdropProps={{
                className: styles.backdrop
            }}
            PaperProps={{
                style: dialogWidth ? { width: dialogWidth } : {}
            }}
        >
            <DialogTitle disableTypography className={styles.dialogTitle}>
                <Typography variant="h6" className={styles.titleText}>
                    {title}
                </Typography>
                {showCloseButton && (
                    <IconButton aria-label="close" onClick={onClose} className={styles.closeButton} size="small">
                        <CloseIcon />
                    </IconButton>
                )}
            </DialogTitle>

            <DialogContent className={styles.dialogContent}>
                <Typography variant="body1" className={styles.messageText}>
                    {message}
                </Typography>

                {true && ( // <-- Conditionally render HTML content
                    <div className={styles.htmlContent} dangerouslySetInnerHTML={{ __html: htmlContent }} />
                )}
            </DialogContent>

            {showActions && (
                <DialogActions className={styles.dialogActions}>
                    {onDisagree && disagreeText && (
                        <LoadingButton loading={disAgreeLoading} onClick={onDisagree} variant="outlined" className={styles.secondaryButton}>
                            {disagreeText}
                        </LoadingButton>
                    )}
                    {onAgree && (
                        <LoadingButton loading={agreeLoading} onClick={onAgree} variant="contained" className={styles.primaryButton}>
                            {agreeText}
                        </LoadingButton>
                    )}
                </DialogActions>
            )}
            <Spinner loading={disAgreeLoading || agreeLoading} />
        </Dialog>
    );
};

MessageDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string,
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    agreeText: PropTypes.string,
    disagreeText: PropTypes.string,
    onAgree: PropTypes.func,
    onDisagree: PropTypes.func,
    showActions: PropTypes.bool,
    disableBackdropClick: PropTypes.bool,
    customClass: PropTypes.string,
    showCloseButton: PropTypes.bool,
    agreeLoading: PropTypes.bool,
    disAgreeLoading: PropTypes.bool,
    htmlContent: PropTypes.string,
    dialogWidth: PropTypes.string
};

export default MessageDialog;
